import React, { useState, useEffect, Fragment } from 'react';
import {
    Row, Button,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Guests_List } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import GuestListItem from "./components/GuestListItem";
import GuestForm from "./components/GuestForm";
import IntlMessages from "../../../../../helpers/IntlMessages";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Pagination from "../../../../../containers/pages/Pagination";

function Index({ propertyId }) {
    const [guestsList, setGuestsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState(moment().subtract(30, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [visible, setVisible] = useState(false);
    const [orderBy, setOrderBy] = useState({ column: "FirstName", label: "First Name" });
    const [search, setSearch] = useState('');
    const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
    const [currentPage, setcurrentPage] = useState(1);
    const [SelectedPageSize, setSelectedPageSize] = useState(10);
    const [TotalItems, setTotalItems] = useState(0);
    const [TotalPages, setTotalPages] = useState(1);
    const orderOptions = [
        { column: "FirstName", label: "First Name" },
        { column: "LastName", label: "Last Name" },
        { column: "CheckInDate", label: "Check In Date" },
        { column: "CheckOutDate", label: "Check Out Date" }
    ]
    useEffect(() => {
        LoadData();
    }, [propertyId, orderBy, search, startDate, endDate, currentPage, SelectedPageSize]);

    const LoadData = () => {
        const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
        const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Guests_List}?groupId=${getGroupID()}&propertyId=${propertyId}&orderBy=${orderBy.column}&search=${search}&dateFrom=${start}&dateTo=${end}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}`,
        })
            .then(res => {
                setGuestsList(res.data.guests);
                setTotalItems(res.data.totalItems)
                setTotalPages(res.data.totalPages)
                setLoading(false);
            })
            .catch(err => console.log('err', err));
    }

    const handleStartDate = (date) => {
        setStartDate(moment(date))
    }
    const handleEndDate = (date) => {
        setEndDate(moment(date))
    }
    const changePageSize = size => {
        setSelectedPageSize(size)
        setcurrentPage(1)
    };
    const onChangePage = page => {
        setcurrentPage(page)
    };
    const toggleModal = () => {
        setVisible(!visible)
    };

    const changeOrderBy = column => {
        setOrderBy(orderOptions.find(
            x => x.column === column
        ))
    };

    const onSearchKey = e => {
        if (e.key === "Enter") {
            setSearch(e.target.value.toLowerCase())
        }
    };

    if (loading) {
        return (
            <div className="loading" />
        );
    }

    const startIndex = (currentPage - 1) * SelectedPageSize;
    const endIndex = currentPage * SelectedPageSize;

    return (
        <Fragment>
            <Row className="app-row survey-app">
                <Colxx xxs="12">
                    <div className="mb-2">
                        <h1>
                            Guests
                        </h1>

                    </div>
                </Colxx>
            </Row>
            <Row>
                <Colxx xxs="3" md="2" className="mb-2">
                    <DatePicker
                        selected={startDate ? new Date(startDate) : null} // ensure Date object
                        onChange={handleStartDate}
                        placeholderText="Start Date"
                        dateFormat="dd/MM/yyyy"
                    />
                </Colxx>
                <Colxx xxs="3" md="2" className="mb-2">
                    <DatePicker
                        selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                        onChange={handleEndDate}
                        placeholderText="End Date"
                        dateFormat="dd/MM/yyyy"   // ✅ correct format
                    />
                </Colxx>

                <Colxx xxs="4">
                    <div className="mb-2">
                        <div className="d-block d-md-inline-block">
                            <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                                <DropdownToggle caret color="outline-dark" size="xs">
                                    <IntlMessages id="pages.orderby" />
                                    {orderBy.label}
                                </DropdownToggle>
                                <DropdownMenu>
                                    {orderOptions.map((order, index) => {
                                        return (
                                            <DropdownItem
                                                key={index}
                                                onClick={() => changeOrderBy(order.column)}
                                            >
                                                {order.label}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                                <input
                                    type="text"
                                    name="keyword"
                                    id="search"
                                    placeholder="Search"
                                    onKeyPress={e => onSearchKey(e)}
                                />
                            </div>
                        </div>
                        {!loading && (
                            <Fragment>
                                <div className="text-zero top-right-button-container">
                                    <Button
                                        color="primary"
                                        size="xs"
                                        outline
                                        className="top-right-button mr-1"
                                        onClick={toggleModal}
                                    >
                                        Add New
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </Colxx>
                <Colxx xxs="2">
                    <div className="float-md-right">
                        <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                        <UncontrolledDropdown className="d-inline-block">
                            <DropdownToggle caret color="outline-dark" size="xs">
                                {SelectedPageSize}
                            </DropdownToggle>
                            <DropdownMenu right>
                                {pageSizes.map((size, index) => {
                                    return (
                                        <DropdownItem
                                            key={index}
                                            onClick={() => changePageSize(size)}
                                        >
                                            {size}
                                        </DropdownItem>
                                    );
                                })}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </Colxx>
            </Row>
            <Separator className="mb-5" />
            <Row>
                {!loading ? (
                    guestsList.map((item, index) => {
                        return (
                            <GuestListItem
                                key={`guest_item_${index}`}
                                item={item}
                                toggleModal={toggleModal}
                                LoadData={LoadData}
                            />
                        );
                    })
                ) : (
                    <div className="loading" />
                )}
            </Row>
            <Row>
                <Pagination
                    currentPage={currentPage}
                    totalPage={TotalPages}
                    onChangePage={i => onChangePage(i)}
                />
            </Row>
            <GuestForm
                toggleModal={toggleModal}
                formLabel="Create a New Guest"
                visible={visible}
                LoadData={LoadData}
            />
        </Fragment >
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
